
import Vue from 'vue'
import {Component, Mixins, Prop, Watch} from 'vue-property-decorator'
import BudgetSheet from './BudgetSheet'
import ReportSheet from './ReportSheet'
import ScopeOfWork from './Scope/ScopeOfWork'
import AAR from './AAR/AfterActionReviewForm'
import AAROverview from './AAR/Overview'
import DDROverview from './DailyReport/Overview'
import PlanningSheetOverview from './PlanningSheet/Overview'
import { Sequence } from '@/types/Sequence'
import convertUnit from '../../utils/convertUnit'
import UserProvisioning from '@/mixins/userProvisioning'
@Component({
    components:{
        'budget-sheet':BudgetSheet,
        'report-sheet':ReportSheet,
        'scope-of-work':ScopeOfWork,
        'ddr-overview':DDROverview,
        'aar-overview':AAROverview,
        'planning-sheet-overview':PlanningSheetOverview,
        'aar':AAR
    },
})
export default class ActivityChart extends Mixins(UserProvisioning) {
    @Prop()
    readOnlyView!:any
    @Prop()
    projectId !:any
    @Prop()
    currentHeight !: any
    editedReport:any={};
    isEdit = false
    contextMenuPosition = { x: 0, y: 0 };
    contextMenuRow = null
    isContextMenuVisible = false
    backModal:any = null;
    showBackModal = false;
    activeReviewId:number = -1
    historyMode = false
    isSubmittedOrUpdated = false;
    filterId : any
    timeArray: Array<any> = [
        {text: 'Year', value: 'YEAR'},
        {text: 'Month', value: 'MONTH'},
        {text: 'Week', value: 'WEEK'},
    ]
    activeView:string = 'gantt'
    visibleTimeUnits: Array<any> = [
        {
            timeUnit:"CURRENT",
            options:{
                fill:'yellow',
                textColor:'blue',
                stroke:'white'
            }
        },
        {
            timeUnit: "YEAR",
            options:{
                fill: this.settingsTime[0].color,
                textColor: 'white',
                stroke: 'white'
            }
        },
        {
            timeUnit:"MONTH",
            options: {
                fill: this.settingsTime[1].color,
                textColor: 'white',
                stroke: 'white'
            }
        },
        {
            timeUnit:"WEEK",
            options: {
                fill: this.settingsTime[2].color,
                textColor: 'white',
                stroke: 'white'
            }
        }
    ]
    timeUnit: string = 'WEEK'

    /*
    chartOptions: any = {
        legend: true,
        constraints: {
            casecadeWest: false,
            cascadeEast: true,
            allowInteraction: this.readOnlyView?false:{checkType:'START_AFTER'},
            boundWest:true,
            boundEast:true,
            allowDrawing:!this.readOnlyView
        }
    }
    */
    sequenceId:number = -1
    defaultWellActivity = {
        id:-1
    }

    start:any = new Date()
    end:any = new Date(this.start.getFullYear()+1,11,31)

    selectedDepts: Array<any> = []
    budgetSheetData:any = {
        activityId:-1,
        budgetTemplateId:-1,
    }

    budgetLumpedSum:boolean = true 
    isEditingDailyReport=false;

    newSequence: Sequence = {
        id:"",
        name: '',          
        rigIds: [],
        rigs:[],
        departmentIds: [],
        departments:[],
        startYear: new Date().getFullYear(),
        endYear: new Date().getFullYear(),
        description: '',
        annualizedBudgets:[],
        riglessBuckets:[],
        userId:0,
        cloneId:0
    }

    get fetchColorSettings () {
        return this.$store.dispatch('settingsModule/getColorSettings')
    }

    get ganttData() {
      const data = {
        projects: this.activities,
        extractor: (a:any) => a.departmentId,
        rows: this.departments.filter((d:any) => this.selectedDepts.includes(d.id)).map((d:any) => d.id),
        rowIdExtractor: (d:any) => d.id
      };
      alert("Yes")
      window.console.log('Gantt Data:', data);
      return data;
    }

    get chartOptions():any{
        return {
            legend: true,
            constraints: {
                casecadeWest: false,
                cascadeEast: true,
                allowInteraction: this.readOnlyView?false:{checkType:this.historyMode?'':'START_AFTER'},
                boundWest:true,
                boundEast:true,
                allowDrawing:!this.readOnlyView
            }
        }
    }

    get activityOptions():any{
        return this.activities.map((thisActivity:any)=>({value:thisActivity.id,text:thisActivity.wellActivity.name}))
    }

    get budgetTemplateOptions():any{
        return this.$store.getters["budgetTemplateModule/getAllTemplates"].map((thisBudgetTemplate:any)=>({value:thisBudgetTemplate.id,text:thisBudgetTemplate.templateName}))
    }

    get milestones():any{
        return this.$store.getters['MilestoneModule/getMilestonesForActivity']
    }
    //end of budget sheet and report sheet data

    get sidenav():any{
        return this.$store.getters['getSideNavStatus']
    }

    get rightPane():any{
        return this.$store.getters['getPaneStatus']
    }

    get project(){
        return this.$store.getters['projectModule/getProjectById'](this.projectId)
    }

    get activities(){
        return this.$store.getters['ActivityModule/getActivitiesForProject'](this.projectId)
    }

    budget(value: any) {
        if (value == null) return "K$ 0.00";
        return "K$ " + parseFloat(value).toFixed(2);
    }

    updateFilteredDepartments(newRows: any) {
        const sortedDept = this.sequence.departments.sort((a: any, b: any) => {
            const indexA = newRows.indexOf(a.id);
            const indexB = newRows.indexOf(b.id);
            if (indexA === -1) return 1;
            if (indexB === -1) return -1;
            return indexA - indexB;
        });

        this.sequence.departments = sortedDept;
        this.newSequence = this.sequence;
        this.newSequence.rigIds = this.sequence.rigs.map((rig:any) => rig.id);
        this.newSequence.departmentIds = this.sequence.departments.map((dept:any) => dept.id);

        this.$store.dispatch('sequencesModule/edit', this.newSequence)
    }

    get departments(){
        return this.sequence.departments?this.sequence.departments:[]
    }

    get deptOptions(){
        let deptOptions = this.sequence.departments?this.sequence.departments.map((d:any) => ({value:d.id,text:d.name})):[]
        this.selectedDepts = deptOptions.map((d:any) => d.value)
        return deptOptions
    }

    get sequence(){
        return this.$store.getters['sequencesModule/getSequence'](this.sequenceId)
    }

    get settingsTime () {
        return this.$store.getters['settingsModule/getTimeSettings']
    }

    get updateRoute(){
        return this.$store.state.ActivityModule.updateRoute
    }

    get getProjectIndexById(){
        return this.$store.getters["projectModule/getProjectIndexById"](this.projectId)
    }

    get getDepartmentOptions() {
        return this.$store.getters['departmentModule/getAllDepartments']
    }

    get totalBudgetForProject(){
        let totalBudget = 0
        if (this.project.costOption === 'LineItem') {
            if (!this.activities.length) return 0
            this.activities.forEach((activity: any) => {
                if(activity.budget){
                    activity.budget.budgetLines.forEach((budgetLine: any) => {
                        totalBudget += budgetLine.lineValue
                    })
                }
            });
        }
        else if (this.project.costOption === 'LumpCost') {
            if (!this.project.departmentBudgets && !this.project.departmentBudgets.length) return 0
                this.project.departmentBudgets.forEach((d:any) => {
                    totalBudget += d.approvedBudget
                });
            // if (!this.sequence || 
            //     !Array.isArray(this.sequence.departments) || 
            //     this.sequence.departments.length === 0
            // ) return 0;
            // const deptIds = this.sequence.departments.map((d: any) => d.id);
            // const departments = this.getDepartmentOptions.filter((d: any) => deptIds.includes(d.id));
            // totalBudget = departments.map((d: any) => d.approvedBudget).reduce((a: any, b: any) => a + b, 0); 
        }
        else if (this.project.costOption === 'DailyCost') {
            totalBudget = this.project.approvedAFEBudget;
        }
        else if (this.project.costOption === 'ProjectCost') {
            if(this.project.approvedBudget && this.project.approvedBudget !== null){
                this.project.approvedBudget.budgetLines.forEach((budgetLine:any) => {
                totalBudget += budgetLine.lineValue
                })
            }
        }
        return totalBudget
    }

    get getAllPlannedMilestonesForProject(){
        let milestoneNames = [] as Array<string>
        this.activities.forEach((activity:any) => {
            activity.milestones.forEach((milestone:any) => {
                milestoneNames.push(milestone.name)
            })
        } )
        return milestoneNames
    }

    get settingswellFluid () {
        return this.$store.getters['settingsModule/getSettingsWell']
    }

    getColorForProject(data: any){
        if (!data.well) return '#FF0000';
        const setting = this.settingswellFluid.find((x:any) => x.propertyName.toLowerCase() === data.well.wellType.toLowerCase())
        if (setting) {
            return setting.backgroundColor;
        }
        return '#FF0000';
    }

    get currentUnitSystem(){
        return this.$store.getters['UnitsModule/getCurrentUnitSystem']
    }

    backToReport(){
        this.activeView='ddr-overview';
        this.isEditingDailyReport = false;
        this.isEdit = false
    }

    gotoGantt() {
        this.activeView='gantt'
        this.isEditingDailyReport = false;
        this.isEdit = false
    }

    gotoProjectView() {
        this.$emit('change-active-view',{view:'projects'})
        this.isEditingDailyReport = false;
        this.isEdit = false
    }

    openBackModal(modal: string){
        if (this.isSubmittedOrUpdated) {
            this.backModal = modal;
            this.continueBackModal();
        }
        else {
            this.showBackModal = true;
            this.backModal = modal;
        }
    }

    reportSubmitted(value: boolean){
        this.isSubmittedOrUpdated = value;
        if(value) this.backToReport();
    }

    closeBackModal(){
        this.showBackModal = false;
        this.backModal = null
    }

    continueBackModal(){
        if (this.backModal === 'report'){
            this.backToReport()
        }
        else if (this.backModal === 'gantt'){
            this.gotoGantt()
        }
        else if (this.backModal === 'project'){
            this.gotoProjectView()
        }

        this.closeBackModal()
    }

    openDailyReportEditor(){
        this.activeView = 'report-sheet';
        this.isEditingDailyReport = false;
        this.isEdit = false
    }
    editDailyReport(dailyReport:any){
        this.activeView="report-sheet";
        this.isEditingDailyReport=true;
        this.editedReport=dailyReport;
        this.isEdit= true
        // this.editedReport.endDepth=convertUnit(dailyReport.endDepth, this.currentUnitSystem, "m" );
        // this.editedReport.startDepth=convertUnit(dailyReport.startDepth, this.currentUnitSystem, "m" );
        // this.editedReport.activityLog = dailyReport.activityLog.map((element: any) => {
        //     if (element) {
        //         return {
        //              id:element.id,
        //              from: element.from,
        //              to: element.to,
        //              hasNpt: element.hasNpt,
        //              activityInProjectId: element.activityInProjectId,
        //              activityId: element.activityId,
        //              activityInProjectName:  this.activities.find((activityInProject:any)=> activityInProject.id == element.activityInProjectId).name,
        //              activityName: this.activities.find((activityInProject:any)=> activityInProject.id == element.activityInProjectId)
        //                         .milestones.find((milestone:any)=> milestone.id == element.activityId).name,
        //              description: element.description,
        //              depth: convertUnit(element.depth, this.currentUnitSystem, "m" ),
        //              nptRef:element.nptRef,
        //              npt:{
        //                 nptDescription: element.npt ? element.npt.nptDescription : '',
        //                 nptHours: element.npt ? element.npt.nptHours : '',
        //                 nptOperationId: element.npt ? element.npt.nptOperationId : '',
        //              }
        //          }
        //     }
        // });
    }

    getAllActualMilestonesForProject(){

    }

    showWellPlanningChecklist(){
        this.activeView = 'planning-sheet-overview'
    }

    showScopeOfWork(){
        this.activeView = 'scope-of-work'
    }

    showAAR(){
        this.activeView = 'aar-overview'
    }

    showReportSheet(){
        this.$store.dispatch(
            "DailyReportModule/getReportsForProject", this.projectId).then(res=> {
        });
        this.activeView = 'ddr-overview'
    }

    showDataSheet(){
        this.$store.dispatch("BudgetModule/getBudgets")
        this.$emit('change-active-view',{view:'project-data-sheet'})
    }

    showPropertyGrid(){
        if(this.rightPane){
            return this.$store.commit('setRightPaneToFalse')
        }else{
            this.$store.commit('setActivePane', 'activity-pane');
            this.$store.commit('setRightPaneToTrue');
        }
    }

    budgetTemplateIdChanged(){
        if(this.budgetSheetData.activityId!=-1)this.$store.dispatch("ActivityModule/updateActivityBudget",{projectIndex:this.getProjectIndexById,projectId:this.projectId,sequenceId:this.sequenceId,id:this.budgetSheetData.activityId,budgetTemplateId:this.budgetSheetData.budgetTemplateId})
    }

    selectedActivityChanged(){
        //if(this.budgetSheetData.activityId=="-1") return 
        this.$store.commit('projectModule/setActiveProject', this.projectId);
        this.$store.commit('projectModule/setActiveSequence', {sequenceId:this.sequenceId,readOnly:this.readOnlyView});
        this.$store.commit('ActivityModule/setActiveActivity', this.budgetSheetData.activityId);
        this.$store.commit('MilestoneModule/setActivityId', this.budgetSheetData.activityId);
        let activity = this.$store.getters["ActivityModule/getActiveActivity"]
        if(activity.budget == null) this.budgetSheetData.budgetTemplateId = "-1"
        else this.budgetSheetData.budgetTemplateId = activity.budget.budgetTemplateId
        if(this.$store.getters['MilestoneModule/getMilestonesForActivity'].length<1){
            this.$store.dispatch("MilestoneModule/getMilestonesForActivity")
        }
    }

    showBudgetSheet(){
        this.activeView = 'budget-sheet'
    }

    getDependency(dependencyId:string){
      if(dependencyId){
        let activity = this.activities.find((thisActivity:any) => thisActivity.id == dependencyId)
        if(activity){
          return {row:activity.departmentId,end:activity.end}
        }else{
          return undefined
        }
      }else{
        return undefined
      }
    }

    departmentClicked(data:any) {
        this.contextMenuRow = data;
        this.isContextMenuVisible = false;
    }

    showContextMenu(rowIdentifier:any, event:any) {
        const menuHeight = 100; // Approximate height of the context menu
        const menuWidth = 200; // Approximate width of the context menu
        const viewportHeight = window.innerHeight;
        const viewportWidth = window.innerWidth;
        
        // Calculate initial position
        let posX = event.clientX;
        let posY = event.clientY - event.offsetY - 80;
        
        // Adjust position if the menu would go out of bounds
        if (posY + menuHeight > viewportHeight) {
            posY = viewportHeight - menuHeight; // Move up
        }
        
        if (event.clientX + menuWidth > viewportWidth) {
            posX = viewportWidth - menuWidth; // Move left
        }
        this.contextMenuPosition = { x: posX, y: posY};
        this.contextMenuRow = rowIdentifier;
        this.isContextMenuVisible = true;
    }

    hideContextMenu() {
        // Hide the context menu
        this.isContextMenuVisible = false;
    }

    AddMenuAction() {
        this.$store.dispatch("ActivityModule/addActivity",{sequenceId:this.sequenceId,projectIndex:this.getProjectIndexById ,newActivity:{
            name:"Pseudo"+ this.activities.length,
            departmentId: this.contextMenuRow,
            start: null,
            end: null,
            milestones:[],
            wellActivity:this.defaultWellActivity
        }})
        const activity = this.activities.find((x:any) => x.departmentId === this.contextMenuRow && (x.start === null || x.end === null))
        if (!activity) return;
        this.$store.commit('projectModule/setActiveProject', this.projectId);
        this.$store.commit('projectModule/setActiveSequence', {sequenceId:this.sequenceId,readOnly:this.readOnlyView});
        this.$store.commit('ActivityModule/setActiveActivity', activity.id);
        this.$store.commit('MilestoneModule/setActivityId', activity.id);
        this.$store.commit('setActivePane', 'activity-pane');
        this.$store.commit('setRightPaneToTrue');
        this.hideContextMenu(); // Hide the context menu after action
    }

    EditMenuAction() {
        const activity = this.activities.find((x:any) => x.departmentId === this.contextMenuRow && (x.start === null || x.end === null))
        if (!activity) return;
        this.$store.commit('projectModule/setActiveProject', this.projectId);
        this.$store.commit('projectModule/setActiveSequence', {sequenceId:this.sequenceId,readOnly:this.readOnlyView});
        this.$store.commit('ActivityModule/setActiveActivity', activity.id);
        this.$store.commit('MilestoneModule/setActivityId', activity.id);
        this.$store.commit('setActivePane', 'activity-pane');
        this.$store.commit('setRightPaneToTrue');
        this.hideContextMenu(); // Hide the context menu after action
    }

    DeleteMenuAction() {
        const activity = this.activities.find((x:any) => x.departmentId === this.contextMenuRow && (x.start === null || x.end === null))
        if (!activity) return;
        this.$store.dispatch('ActivityModule/deleteActivity', {sequenceId:this.sequenceId,projectIndex:this.getProjectIndexById,id:activity.id})
        this.hideContextMenu(); // Hide the context menu after action
    }

    getDepartmentName(id:string){
        return this.departments.find((d:any) => d.id == id).name
    }

    //methods
    takeRightPane() {
        this.hideContextMenu();
        return this.$store.commit('setRightPaneToFalse')
    }

    singleClickEvent(activityId: any) {
        this.$store.commit('projectModule/setActiveProject', this.projectId);
        this.$store.commit('projectModule/setActiveSequence', {sequenceId:this.sequenceId,readOnly:this.readOnlyView});
        this.$store.commit('ActivityModule/setActiveActivity', activityId);
        this.$store.commit('MilestoneModule/setActivityId', activityId);
        this.$store.commit('setActivePane', 'activity-pane');
        this.$store.commit('setRightPaneToTrue');
        this.budgetSheetData.activityId = activityId
        let activity = this.$store.getters["ActivityModule/getActiveActivity"]
        if(activity.budget != null) this.budgetSheetData.budgetTemplateId = activity.budget.budgetTemplateId
    }

    drawingStart(data: any){
        if (!this.canWriteSequence) {
            this.chartOptions.constraints.allowDrawing = false;
            return;
        }
        if(this.readOnlyView)return
        let date = new Date(data.startDate)
        let today = new Date()
        if((date < today)&&(!this.historyMode)){
            if(this.chartOptions.constraints.allowDrawing){
                this.chartOptions.constraints.allowDrawing = false
                this.$bvToast.toast('You are attempting to add an activity in the past. Activity start date must be greater than today.', {
                    title: 'Please Note!!!',
                    autoHideDelay: 10000,
                    appendToast: true,
                    toaster: 'b-toaster-bottom-right',
                    solid: true,
                    variant: 'danger'
                })
            }
        }else{
            this.chartOptions.constraints.allowDrawing = true
        }
    }

    drawingEnd(data:any){
        this.$store.dispatch("ActivityModule/addActivity",{sequenceId:this.sequenceId,projectIndex:this.getProjectIndexById ,newActivity:{
            name:"name"+this.activities.length,
            departmentId:data.row,
            start:data.startDate.getFullYear()+"-"+((data.startDate.getMonth()+1)<10?('0'+(data.startDate.getMonth()+1)):data.startDate.getMonth()+1)+"-"+(data.startDate.getDate()<10?('0'+data.startDate.getDate()):data.startDate.getDate()),
            end:data.endDate.getFullYear()+"-"+((data.endDate.getMonth()+1)<10?('0'+(data.endDate.getMonth()+1)):data.endDate.getMonth()+1)+"-"+(data.endDate.getDate()<10?('0'+data.endDate.getDate()):data.endDate.getDate()),
            milestones:[],
            wellActivity:this.defaultWellActivity
        }})
    }

    convert (date: any) {
        var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2) 
            month = '0' + month;
        if (day.length < 2) 
            day = '0' + day;

        return [year, month, day].join('-');
    }

    barMoveEnded(data:any){
        data.startDate = data.startDate.getFullYear()+"-"+((data.startDate.getMonth()+1)<10?('0'+(data.startDate.getMonth()+1)):data.startDate.getMonth()+1)+"-"+(data.startDate.getDate()<10?('0'+data.startDate.getDate()):data.startDate.getDate())
        data.endDate = data.endDate.getFullYear()+"-"+((data.endDate.getMonth()+1)<10?('0'+(data.endDate.getMonth()+1)):data.endDate.getMonth()+1)+"-"+(data.endDate.getDate()<10?('0'+data.endDate.getDate()):data.endDate.getDate())
        this.$store.dispatch("ActivityModule/updateActivity",{projectIndex:this.getProjectIndexById,projectId:this.projectId,sequenceId:this.sequenceId,id:data.id,start:data.startDate,end:data.endDate})
    }

    @Watch('sidenav')
    onSideNavChanged(val:boolean){
        setTimeout(() => {
            if(this.activeView == 'gantt') {
                if (this.$refs && this.$refs.gantt2) {
                    ((this.$refs.gantt2) as any).resize();
                    ((this.$refs.gantt2) as any).adjustScaleX();
                }
            }
        }, 400);
    }

    @Watch('rightPane')
    onRigthPaneChanged(val:boolean){
        setTimeout(() => { 
            if(this.activeView == 'gantt') {
                if (this.$refs && this.$refs.gantt2) {
                    ((this.$refs.gantt2) as any).resize();
                    ((this.$refs.gantt2) as any).adjustScaleX();
                }
            }
        }, 400);
    }

    barMouseEnter() {
        if(this.activeView == 'gantt') {
            if (this.$refs && this.$refs.gantt2) {
                ((this.$refs.gantt2) as any).resize();
                ((this.$refs.gantt2) as any).adjustScaleX();
            }
        }
    }

    mounted(){
        this.$store.dispatch('departmentModule/getDepartments')
        if(!this.project){
            this.$store.dispatch("projectModule/getProject",this.projectId).then((res:any) => {
                if(this.project){
                    this.sequenceId = this.project.sequenceId
                    this.$store.dispatch("sequencesModule/getSequence",this.project.sequenceId)
                }
            })
        }else{
            this.sequenceId = this.project.sequenceId
            this.start = this.project.start
            this.end = this.project.end
        }

        if(this.budgetTemplateOptions.length<1){
            this.$store.dispatch("budgetTemplateModule/fetchBudgetTemplates")
        }
    }

    created(){
        if (this.settingswellFluid.length < 1)
            this.fetchColorSettings.then(() => {})
        this.filterId = Math.abs((Math.floor(Math.random() * (10 - +4000))  +10)+(Math.floor(Math.random() * (10 - +4000))  +10)).toString()
    }
}
